import React, { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

// Password input with show/hide eye toggle.
// Keeps the same dark/yellow styling used across the app.
export const PasswordInput = ({
  value,
  onChange,
  testid,
  required = false,
  minLength,
  autoComplete = "current-password",
  className = "",
  placeholder,
}) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testid}
        type={show ? "text" : "password"}
        required={required}
        minLength={minLength}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        placeholder={placeholder}
        className={
          "w-full bg-[#0B0D11] border border-white/10 pl-4 pr-12 py-3 text-white focus:border-primary-yellow focus:outline-none focus:ring-1 focus:ring-primary-yellow " +
          className
        }
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        aria-label={show ? "Hide password" : "Show password"}
        title={show ? "Hide password" : "Show password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/50 hover:text-primary-yellow transition-colors p-1"
      >
        {show ? <EyeSlash size={18} weight="bold" /> : <Eye size={18} weight="bold" />}
      </button>
    </div>
  );
};

export default PasswordInput;
